<template>
	<div>
		<div style="padding-top: 4rem">
			<div class="">
				<div style="font-weight: 700" class="alert alert-warning text-center">
					<h4>YOU ARE SUBMITTING ANNUAL REPORT</h4>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4 mb-3" @click="report_type = 'amount_received'">
					<div class="card">
						<div class="card-body text-center">
							<i class="feather icon-briefcase f-30"></i>
							<h4 class="card-title">Amount Received</h4>
							<p class="card-text">
								Click here to enter details of all amounts received during the
								reporting period.
							</p>
						</div>
					</div>
				</div>
				<div class="col-md-4 mb-3" @click="report_type = 'amount_expended'">
					<div class="card">
						<div class="card-body text-center">
							<i class="fa fa-credit-card fa-2x"></i>
							<h4 class="card-title">Amount Expended</h4>
							<p class="card-text">
								Click here to enter details of all amounts expended during the
								reporting period.
							</p>
						</div>
					</div>
				</div>
				<div
					class="col-md-4 mb-3"
					@click="report_type = 'contributions_donations'"
				>
					<div class="card">
						<div class="card-body text-center">
							<i class="fa fa-gift fa-2x"></i>
							<h4 class="card-title">Contributions &amp; Donations</h4>
							<p class="card-text">
								Click here to enter details of all contributions and donations
								received.
							</p>
						</div>
					</div>
				</div>
				<div class="col-md-4 mb-3" @click="report_type = 'assets'">
					<div class="card">
						<div class="card-body text-center">
							<i class="fa fa-building fa-2x"></i>
							<h4 class="card-title">Assets</h4>
							<p class="card-text">
								Click here to enter details of all assets owned during the
								reporting period.
							</p>
						</div>
					</div>
				</div>
				<div class="col-md-4 mb-3" @click="report_type = 'liabilities'">
					<div class="card">
						<div class="card-body text-center">
							<i class="fa fa-balance-scale fa-2x"></i>
							<h4 class="card-title">Liabilities</h4>
							<p class="card-text">
								Click here to enter details of all liabilities owed during the
								reporting period.
							</p>
						</div>
					</div>
				</div>
				<div class="col-md-4 mb-3" @click="report_type = 'bank_details'">
					<div class="card">
						<div class="card-body text-center">
							<i class="fa fa-balance-scale fa-2x"></i>
							<h4 class="card-title">Bank Details</h4>
							<p class="card-text">
								Click here to enter the bank details of every report submitted.
							</p>
						</div>
					</div>
				</div>
			</div>

			<div>
				<AmountReceived v-if="report_type === 'amount_received'" />

				<AmountExpended v-if="report_type === 'amount_expended'" />

				<ContributionAndDonation
					v-if="report_type === 'contributions_donations'"
				/>

				<Assets v-if="report_type === 'assets'" />

				<Liabilities v-if="report_type === 'liabilities'" />

				<BankDetails v-if="report_type === 'bank_details'" />
			</div>
		</div>
		<div align="center" style="bottom: 0">
			<router-link
				to="/forms/annual-report"
				tag="button"
				class="btn btn-secondary me-2"
				>Back to List</router-link
			>
		</div>
	</div>
</template>
<script>
import AmountReceived from "./partials/AmountReceived.vue";
import AmountExpended from "./partials/AmountExpended.vue";
import ContributionAndDonation from "./partials/ContributionAndDonation.vue";
import { EventBus } from "@/utils/event_bus.js";
import { mapActions } from "vuex";
import Assets from "./partials/Assets.vue";
import Liabilities from "./partials/Liabilities.vue";
import BankDetails from "./partials/BankDetails.vue";
// import dayjs from "dayjs";

export default {
	name: "AnnualAdd",
	components: {
		Assets,
		Liabilities,
		BankDetails,
		AmountReceived,
		AmountExpended,
		ContributionAndDonation,
	},
	data() {
		return {
			report_type: null,
		};
	},
	methods: {
		...mapActions({
			getFormByID: "form_ec16c/getFormByID",
		}),
	},
	mounted() {
		this.getFormByID({ formID: this.$route.params.formID });

		EventBus.$on("toggle-modal", (type) => {
			if (type == "hide") {
				this.report_type = "";
			}
			this.toggle_modal = type;
		});
	},
};
</script>
<style scoped>
.card-body:hover {
	background: #29623c;
	color: #fff !important;
	cursor: pointer;
}

.card-body:hover .card-title {
	color: #fff !important;
}
</style>
